






import { Prop, Component, Vue } from 'vue-property-decorator'

export type DistinguishCallback<T> = (item: T) => string

@Component
export default class ListItemDistinguisher extends Vue {
    @Prop({ type: String, default: 'black' }) readonly color!: string

    get distinguishableStyle(): object {
        return {
            '--distinguishable-color': this.color,
        }
    }
}
